import React from 'react';
import { Section } from './ui/Section';
export function ContentOverview() {
  const tomos = [{
    number: 'Tomo 1',
    title: 'El Despertar Sin Trigo',
    tagline: 'Prepara tu cuerpo para el cambio en 3 días.',
    points: ['Ciencia de la desinflamación', 'Protocolo reset de 3 días', 'Preparación del cuerpo para el cambio'],
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e513b7c7-8bec-44b2-aef2-8fbe61d742a1.jpg'
  }, {
    number: 'Tomo 2',
    title: 'La Panadería Prohibida',
    tagline: 'El mismo pan de siempre, sin trigo.',
    points: ['12 recetas de pan sin gluten', 'Mismo crujido y miga', 'Mismo aroma que el pan de trigo'],
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/aa63e646-02f9-4ea7-b435-be5881cae257.jpg'
  }, {
    number: 'Tomo 3',
    title: 'El Imperio de la Pasta',
    tagline: 'Tu pasta de siempre, sin carbohidratos refinados.',
    points: ['Carbonara, lasaña, pesto y fideuà', 'Método del mimetismo nutricional', 'Sin carbohidratos refinados'],
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7ad5ad3d-7c30-45b6-974b-34f44ab275b1.jpg'
  }, {
    number: 'Tomo 4',
    title: 'Pizzas, Rebozados y Tapeo',
    tagline: 'El viernes y el tapeo, sin renunciar.',
    points: ['El ritual del viernes', 'El placer del bar y el tapeo', 'Versión 100% desinflamatoria'],
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/2dc28840-75d6-4cc2-bdc0-2ed41966abc2.jpg'
  }, {
    number: 'Tomo 5',
    title: 'Dulce Libertad',
    tagline: 'Repostería con todo el placer, sin harina ni azúcar.',
    points: ['Sin harina ni azúcar', 'Todo el placer, sin resignación', 'Sistema anti-antojos completo'],
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e0ee02ce-49ea-49ff-bbc5-eb9cd79067b8.jpg'
  }, {
    number: 'Tomo 6',
    title: 'El Sistema de Mantenimiento',
    tagline: 'El cambio que se mantiene para siempre.',
    points: ['Plan de mantenimiento de 90 días', 'Bodas, Navidades y viajes', 'Psicología del cambio permanente'],
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/1203228e-b368-4e70-a238-9b8b3e6c61ba.jpg'
  }];
  return <Section data-id="element-41" data-mp="18s80pf0yps1">
      <h2 className="font-display text-2xl md:text-4xl font-bold text-center mb-3 text-brand-title" data-id="element-42" data-mp="f1qa0ulz3g4k">
        Lo que vas a recibir
      </h2>
      <p className="text-center text-brand-textMuted mb-12 font-body" data-id="element-43" data-mp="a47z4yoeaqtx">
        6 Tomos, cada uno con su propio terreno de juego.
      </p>

      <div className="max-w-4xl mx-auto space-y-6 md:space-y-10" data-id="element-44" data-mp="3ikjk2xfjlmtz">
        {tomos.map((tomo, i) => {
        const imageFirst = i % 2 === 0;
        return <div key={i} className="bg-white border border-brand-border rounded-2xl overflow-hidden shadow-card md:grid md:grid-cols-2" data-id="element-45" data-mp="3shxnnwgdah4v" data-mpi={i}>
              <div className={`aspect-[4/3] md:aspect-auto overflow-hidden ${imageFirst ? 'md:order-1' : 'md:order-2'}`} data-id="element-46" data-mp="3njw6jh2i4rw1">
                <img src={tomo.img} alt={tomo.title} className="w-full h-full object-cover" loading="lazy" data-id="element-47" data-mp="12rkkj5itksln" />
              </div>
              <div className={`p-6 md:p-8 flex flex-col justify-center ${imageFirst ? 'md:order-2' : 'md:order-1'}`} data-id="element-48" data-mp="2koxp5r3y5hgx">
                <div className="text-brand-secondary font-heading italic text-sm mb-1.5 tracking-wide" data-id="element-49" data-mp="2pp390l3z5zog">
                  {tomo.number}
                </div>
                <h3 className="font-display text-xl md:text-2xl font-bold text-brand-title mb-2" data-id="element-50" data-mp="2gnc5nmwwq4xr">
                  {tomo.title}
                </h3>
                <p className="font-body text-brand-primary font-semibold text-sm mb-4" data-id="element-51" data-mp="34dpz9hv54bug">
                  {tomo.tagline}
                </p>
                <ul className="space-y-1.5" data-id="element-52" data-mp="2unejmy23ge7q">
                  {tomo.points.map((point, j) => <li key={j} className="flex items-start gap-2 text-sm text-brand-text font-body" data-id="element-53" data-mp="2ulahakjufn9k" data-mpi={j}>
                      <span className="text-brand-primary font-bold shrink-0" data-id="element-54" data-mp="2zkdg3n98cx93">
                        ✓
                      </span>
                      {point}
                    </li>)}
                </ul>
              </div>
            </div>;
      })}
      </div>
    </Section>;
}